import React from 'react';
import styled from 'styled-components';
import { colorTokens } from '../../../../../tokens/globals/tokens';
import HStack from '../../../../HStack/HStack';
import Box from '../../../../Box/Box';
import { useSiteKit } from '../../SiteKitContext/SiteKitContext';

// Subcomponents
import { SiteKitSignPost } from '../SiteKitSignPost/SiteKitSignPost';

// Fragments
const SiteKitHeaderWrapper = styled.header`
  border-bottom: ${({ theme }) => (theme.hasLocalNav ? 'none' : `1px solid ${colorTokens.GlobalBrandGray40}`)};
`;

// Exports
interface SiteKitHeaderProps {
  children: React.ReactNode;
  hasLocalNav?: boolean;
}
const SiteKitHeader = ({ children, hasLocalNav = false }: SiteKitHeaderProps) => {
  const { isMobileOrTablet, sidebarOpen } = useSiteKit();
  return (
    <SiteKitHeaderWrapper theme={{ hasLocalNav }}>
      <Box
        top="large"
        bottom={hasLocalNav ? 'small' : 'large'}
        right="gutter"
        left={!sidebarOpen || isMobileOrTablet ? '7px' : 'gutter'}
      >
        <HStack align="distributed" alignY="center" spacing="medium">
          {children}
        </HStack>
      </Box>
    </SiteKitHeaderWrapper>
  );
};

SiteKitHeader.SignPost = SiteKitSignPost;

SiteKitHeader.displayName = 'SiteKit.Header';

export { SiteKitHeader, SiteKitHeaderProps };
